import { useEffect, useState } from 'react';
import { getNutritionStats, getNutritionItems, getNutritionTreats } from './api';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import SectionHeader from './SectionHeader';

const COLORS = ['#8b7355', '#a0956b', '#c4a882', '#d4bfa0', '#e8d5bc', '#b89a72'];

const PERIOD_OPTIONS = [
  { label: '2 мес', value: 2 },
  { label: '6 мес', value: 6 },
  { label: '12 мес', value: 12 },
];

export default function NutritionBlock({ petId, pdfPath, pdfName, docs, onDocsClick }) {
  const [months, setMonths] = useState(2);
  const [stats, setStats] = useState(null);
  const [feedItems, setFeedItems] = useState([]);
  const [treats, setTreats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      getNutritionStats(petId, months),
      getNutritionItems(petId, months),
      getNutritionTreats(petId, months),
    ])
      .then(([s, f, t]) => { setStats(s); setFeedItems(f); setTreats(t); })
      .catch(() => { setStats(null); setFeedItems([]); setTreats([]); })
      .finally(() => setLoading(false));
  }, [petId, months]);

  const items = stats?.items || [];

  return (
    <section className="card-section" id="section-nutrition">
      <SectionHeader
        title="Питание"
        pdfPath={pdfPath}
        pdfName={pdfName}
        periodMode="days_years"
        sectionKey="nutrition"
        docs={docs}
        onDocsClick={onDocsClick}
      />

      {/* Переключатель периода */}
      <div className="visits-period-tabs">
        {PERIOD_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            className={`visits-tab${months === opt.value ? ' visits-tab-active' : ''}`}
            onClick={() => setMonths(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {loading ? null : items.length === 0 ? (
        <p style={{ color: '#888', fontSize: 13, margin: 0 }}>Нет данных за этот период</p>
      ) : (
        <>
          {/* Круговая диаграмма */}
          <div className="nutrition-chart-wrap" style={{ paddingBottom: 0, borderBottom: 'none' }}>
            <ResponsiveContainer width="100%" height={280}>
              <PieChart>
                <Pie
                  data={items}
                  dataKey="count"
                  nameKey="food_type"
                  cx="50%"
                  cy="42%"
                  outerRadius={80}
                  innerRadius={38}
                >
                  {items.map((_, i) => (
                    <Cell key={i} fill={COLORS[i % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(value, name, props) => [
                    `${props.payload.percent}% (${value} раз)`,
                    props.payload.food_type,
                  ]}
                  contentStyle={{ borderRadius: 8, fontSize: 12 }}
                />
                <Legend
                  verticalAlign="bottom"
                  formatter={(value) => (
                    <span style={{ fontSize: 12, color: '#2d2d2d' }}>{value}</span>
                  )}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>

          {/* Список рационов и кормов */}
          {feedItems.length > 0 && (
            <div className="nutr-items">
              <div className="nutr-items-title">Состав рациона за период</div>
              {feedItems.map((f, i) => (
                <div key={i} className="nutr-item">
                  <div className="nutr-item-header">
                    <span className="nutr-item-label">{f.label}</span>
                    <span className="nutr-item-amount">{f.ration_weight > 0 ? `${f.ration_weight} г · ` : ''}с {f.first_date}</span>
                  </div>
                  {f.products.length > 0 && (
                    <div className="nutr-item-products">
                      {f.products.map((p, j) => (
                        <div key={j} className="nutr-item-product">
                          • {p.name} — {p.amount} г
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Лакомства */}
          {treats.length > 0 && (
            <div className="nutr-items">
              <div className="nutr-items-title">Лакомства</div>
              <div className="nutr-treats-list">
                {treats.map((t, i) => (
                  <span key={i} className="nutr-treat-chip">{t}</span>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </section>
  );
}
